var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',[_c('v-list-item',{staticClass:"pl-0",attrs:{"dark":""}},[_c('router-link',{attrs:{"to":"/"}},[_c('v-img',{attrs:{"src":require('@/styles/videocms_streamon logo_white.png')}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }